import { Badge } from "@/components/ui/Badge";

const StrengthScore = ({ score, max = 5 }) => {
  const ratio = score / max;
  const colorIndex = ratio >= 0.8 ? 2 : ratio >= 0.6 ? 4 : ratio >= 0.4 ? 6 : 8;

  return (
    <Badge
      label={`${score}/${max}`}
      colorIndex={colorIndex}
      variant="gradient"
      className="w-fit !text-text-primary rounded-full"
      badgeStyle="md:!py-[1px] py-0 text-xs md:text-sm"
    />
  );
};

export default StrengthScore;
